export default {
  'menu.login': 'Login',
  'menu.onboarding': 'Onboarding',
  'menu.onboarding.applications': 'Applications',
  'menu.village-ops': 'Village Operations',
  'menu.village-ops.overview': '吾村仪表盘',
  'menu.village-ops.activities': 'Activities',
  'menu.village-ops.jobs': 'Job Notices',
  'menu.village-ops.products': 'Products',
  'menu.village-ops.resolutions': 'Village Resolutions',
  'menu.village-ops.impressions': 'Impressions',
  'menu.village-ops.short-videos': 'Video Management',
  'menu.village-ops.product-orders': 'Product Orders',
  'menu.village-ops.villagers': 'Villagers',
  'menu.village-ops.artisans': 'Artisans',
  'menu.village-ops.villager-applications': 'Villager Applications',
  'menu.village-ops.profile': 'Village Info',
  'menu.platform-governance': 'Platform Governance',
  'menu.platform-governance.users': 'User Management',
  'menu.platform-governance.villages': 'Village Management',
  'menu.platform-governance.banners': 'Banners',
  'menu.platform-governance.announcements': 'Announcements',
  'menu.platform-governance.system-parameter': 'System Parameters',
  'menu.platform-governance.category-configs': 'Category Management',
  'menu.platform-governance.monitoring-events': 'Behavior Logs',
  'menu.platform-governance.sms-messages': 'Message Center',
  'menu.platform-governance.help-faq': 'FAQ Management',
  'menu.platform-governance.feedbacks': 'Feedback Management',
  'menu.platform-governance.content-reports': 'Content Reports',
  'menu.platform-governance.short-videos': 'Short Videos',
  'menu.platform-governance.dictionaries': 'Dictionaries',
  'menu.platform-governance.admin-roles': 'Admin Roles',
  'menu.platform-governance.admin-menus': 'Menu Configuration',
  'menu.platform-governance.admin-permissions': 'Permission Configuration',
};
